import { useState } from 'react';

import { useNotifications } from 'core/hooks/useNotifications';
import { client, useErrorNotifications } from 'core/http';
import { Product } from 'core/types/product';

export default function useProductsImport() {
  const showErrorNotification = useErrorNotifications();
  const showNotification = useNotifications({ variant: 'success' });
  const [loading, setLoading] = useState(false);

  const importProducts = (file: File) => {
    setLoading(true);

    const formData = new FormData();
    formData.append('products', file);

    return client()
      .post<Array<Product & { pivot: { price: number } }>>(
        `products/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      .then((response) => {
        showNotification(
          `Päivitettiin ${response.data.length} tuotetta. Päivitä sivu nähdäksesi muutokset heti.`
        );
        return response.data;
      })
      .catch((error) => {
        showErrorNotification(error);
        throw error;
      })
      .finally(() => setLoading(false));
  };

  return { importProducts, loading };
}
